import { Users } from '../../constants/apis';
import type { SearchUserResponse } from '../../types/iam/search';
import { ApiManager } from '../axios-config';

export const searchUser = (query: string, pageSize = 5) => {
  return ApiManager.get<SearchUserResponse>(`${Users}/search`, {
    params: {
      searchQuery: query,
      pageSize,
    },
  });
};
